export const OWNERSHIP_ITEM = 1;
export const BUCKET_ITEM = 2;
export const SHARED_ITEM = 3;
